module.exports = __webpack_public_path__ + "img/maintenance.08c4c4f6.svg";